import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/product';

export class ProductService extends RestServiceConnection {

    listProducts = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getProductTypes = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-types',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getProductById = async (productId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { productId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    getProductDocuments = async (productId: string, maxResults: number = 10, documentTypeId?: number) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-documents',
            data: { productId, maxResults, documentTypeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleProductStatus = async (productId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { productId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }


    createProduct = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: entity,
            headers: {
                "Content-Type": "application/json"
            }
        }, true);
        return this;
    }

    editProduct = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: entity,
            headers: {
                "Content-Type": "application/json"
            }
        }, true);
        return this;
    }

    updateContractWatermark = async (productId: string, contractWatermark?: File | null, removeContractWatermark?: boolean) => {
        const formData = new FormData();
        formData.append('productId', productId);

        if (contractWatermark) {
            formData.append('contractWatermark', contractWatermark);
        }

        if (removeContractWatermark) {
            formData.append('removeContractWatermark', '1');
        }

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/update-contract-watermark',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    deleteProduct = async (productId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { productId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiProducts = async (productsIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { productsIds },
        }, true);
        return this;
    }

    getContractFields = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/get-contract-fields',
        }, true) as AxiosResponse<{ data: any[] }>;
        return this;
    }

    previewContractTemplate = async (templateContent: string, contractId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/preview-contract-template',
            data: { templateContent, contractId },
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    listProductsForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-products-for-select',
            data: filters,
        }, true);
        return this;
    }

    exportProductsXLSX = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-xlsx',
            data: filters,
            responseType: 'arraybuffer',
        }, true);
        return this;
    }

    exportProductsXML = async (filters: any, productsIds: string[] = []) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-xml',
            data: {
                ...filters,
                productsIds,
            },
            responseType: 'arraybuffer',
        }, true);
        return this;
    }

    downloadProductsImportTemplateXLSX = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/import-template-xlsx',
            responseType: 'arraybuffer',
        }, true);
        return this;
    }

    importProductsXLSX = async (productsExcelFile: File, importMode: 'preview' | 'upsert' | 'create_only' | 'update_only') => {
        const formData = new FormData();
        formData.append('productsExcelFile', productsExcelFile);
        formData.append('importMode', importMode);

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import-xlsx',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

}
